import type { SharedLocale } from '../types/locales';
import { useStoryblokClient } from './useStoryblokClient';

export interface LMGridIndustriesTag {
  value: string;
  labelSingular: string;
  labelPlural: string;
}

export async function useLMGridIndustriesTags(locale: SharedLocale): Promise<LMGridIndustriesTag[]> {
  const { getDatasourceEntries } = await useStoryblokClient();

  const tagsData = await getDatasourceEntries('lm-grid-industries-tags', locale);

  return (tagsData.value ?? []).map(tag => {
    const [labelSingular, labelPlural] = (tag.dimension_value ?? tag.name).split('|');

    return {
      value: tag.value ?? '',
      labelSingular,
      labelPlural,
    };
  });
}
